// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';

// Misc / utils
import * as S from './styles';

const BathButtons = ({ handleClick, state }) => {
  const BATH_CATEGORIES = [
    {
      value: 'any',
      display: 'Any',
      ariaLabel: 'Any bathroom configuration',
    },
    {
      value: 'oneOrMore',
      display: '1+',
      ariaLabel: '1 or more bathrooms',
    },
    {
      value: 'oneHalfOrMore',
      display: '1.5+',
      ariaLabel: '1.5 or more bathrooms',
    },
    {
      value: 'twoOrMore',
      display: '2+',
      ariaLabel: '2 or more bathrooms',
    },
    {
      value: 'threeOrMore',
      display: '3+',
      ariaLabel: '3 or more bathrooms',
    },
    {
      value: 'fourOrMore',
      display: '4+',
      ariaLabel: '4 or more bathrooms',
    },
  ];

  return (
    <S.FlexList role="group" aria-labelledby="bathroom-filter">
      {BATH_CATEGORIES.map((bath) => {
        return (
          <S.FlexListItem key={`bath-category-${bath.value}-${bath.ariaLabel}`}>
            <S.ToggleButton
              onClick={handleClick}
              data-option-value={bath.value}
              isPressed={state[bath.value] === true}
              ariaPressed={state[bath.value] === true}
              ariaLabel={bath.ariaLabel}
            >
              {bath.display}
            </S.ToggleButton>
          </S.FlexListItem>
        );
      })}
    </S.FlexList>
  );
};

export default BathButtons;
